export var supportedContracts = [
    { address: '0xf2AcABf89Cb828DAa66bEd982acAa62d60B8e636', chainId: 1 },
    { address: '0x5D22265f55321fD8019235a3B88130f0083Add1e', chainId: 10 },
    { address: '0xdDFE0b8dF3cA09bABBa20e2D7D1Cdf43eFDf605f', chainId: 42161 },
    { address: '0x9872fC91F45Aed06F967C27DF270fB4f671C3D78', chainId: 8453 },
    { address: '0x942CA50D87FDf2DadC2C7F1eaBB97935c137D6Fd', chainId: 11155111 },
];
